import React from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import ROUTES from "./routes";
import SignedInLayout from "../../view/layout/SignedInLayout";
import ViewPropsFactory from "../factory/view-props/ViewPropsFactory";
import ViewStore from "../ViewStore";
import OfferPanelPage from "../../view/page/offer-panel/OfferPanelPage";

const Routing: React.FC<{ viewPropsFactory: ViewPropsFactory, viewStore: ViewStore }> = (props) => {
    const [searchParams] = useSearchParams();

    return <>{ signedInRoutes(props.viewPropsFactory, props.viewStore, searchParams) }
    </>

}
export default Routing;

const signedInRoutes = (propsFactory: ViewPropsFactory, viewStore: ViewStore, searchParams: URLSearchParams) => {

    if (searchParams.get('redirect')) {
        return redirection(searchParams.get('redirect')!);
    }

    return (
        <SignedInLayout>
            <Routes>
                <Route path={ ROUTES.APP() }
                       element={ <OfferPanelPage { ...propsFactory.offerPanel() } /> }
                />

                {/*<Route path="*" element={ <Navigate to={ ROUTES.ROOT() }/> }/>*/}
            </Routes>
        </SignedInLayout>
    );
}


const redirection = (location: string) => {
    return (
        <Routes>
            <Route path="*" element={ <Navigate to={ location }/> }/>
        </Routes>
    );
}
